export default "__VITE_ASSET__BlimVwzE__"